import { render, staticRenderFns } from "./buttonResetQuestion.vue?vue&type=template&id=7d959eb8"
import script from "./buttonResetQuestion.vue?vue&type=script&lang=js"
export * from "./buttonResetQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports